module.exports = __webpack_public_path__ + "static/PurpleAds-3a83553096e11c4366976bdaadc1c622.svg";